export default __webpack_public_path__ + "static/media/about01.080509de.png";